import { atom } from 'jotai';

export const walletModalOpenAtom = atom(false);
